var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeCloudIQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "87.58984375 87.2109375 693.6484375 203.6484375",
    style: {
      enableBackground: "new 0 0 868.64 377.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;}\t.st1{fill:none;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 539.08,
    y: 195.27,
    className: "st0",
    width: 12.82,
    height: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.57,145.64c-17.82,0-36.93,12.05-36.93,38.71s19.11,38.52,36.93,38.52c4.31,0,8.63-0.74,12.99-2.18   l-18.74-20.5l18.89-15.85l18.74,20.53c3.06-5.6,4.87-12.24,4.87-20.53C722.31,157.7,703.23,145.64,685.57,145.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M751.86,184.53c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61   c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85L737.43,227   C746.43,216.02,751.86,201.64,751.86,184.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M751.86,184.53c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61   c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85L737.43,227   C746.43,216.02,751.86,201.64,751.86,184.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.59,87.21v108.06h13.81v15.9h-13.81v79.69h224.65V87.21H556.59z M608.79,246.94h-23.54v-52.13h23.54   V246.94z M608.79,183.04h-23.54V159.5h23.54V183.04z M734.37,259.96l-15.68-17.29c-9.7,5.42-21.25,8.29-33.13,8.29   c-36.04,0-66.48-26.1-66.48-66.43c0-40.51,30.43-66.61,66.48-66.61c35.86,0,66.29,26.1,66.29,66.61c0,17.1-5.42,31.48-14.42,42.47   l15.68,17.1L734.37,259.96z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.59,190.58c0-34.97,27.8-63.31,62.77-63.31c19.01,0,35.51,8.07,46.45,20.98l-11.84,10.04   c-8.25-9.68-20.8-15.96-34.61-15.96c-26,0-46.45,21.7-46.45,48.24c0,26.36,20.44,48.24,46.45,48.24c13.81,0,26.36-6.28,34.61-15.96   l11.84,10.04c-10.94,12.91-27.44,20.98-46.45,20.98C115.39,253.88,87.59,225.55,87.59,190.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.39,122.61h15.6v129.48h-15.6V122.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.36,209.94c0-26.54,19.91-43.4,43.76-43.4c23.85,0,43.94,16.86,43.94,43.4   c0,26.54-20.08,43.94-43.94,43.94C255.27,253.88,235.36,236.49,235.36,209.94z M307.46,209.94c0-17.22-12.91-28.69-28.33-28.69   c-15.24,0-27.98,11.48-27.98,28.69c0,17.4,12.73,29.23,27.98,29.23C294.54,239.18,307.46,227.34,307.46,209.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.83,168.34v83.75h-15.6V239c-5.02,10.4-18.47,14.88-27.8,14.88c-20.98,0-33.89-13.63-33.71-37.12v-48.42   h15.6v47.52c0,13.99,8.43,22.6,20.08,22.6c11.66,0,25.65-6.63,25.83-24.75v-45.37H411.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.72,122.61v129.48h-15.6v-13.27c-5.56,9.68-17.75,15.06-29.77,15.06c-22.96,0-41.96-17.4-41.96-43.76   c0-26.54,18.83-43.58,41.79-43.58c12.55,0,24.39,5.02,29.95,14.88v-58.82H511.72z M496.11,209.94c0-18.11-14.71-28.69-28.51-28.69   c-15.24,0-27.44,11.84-27.44,28.69c0,16.68,12.2,29.23,27.44,29.23C482.66,239.18,496.11,227.88,496.11,209.94z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeCloudIQ);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_Cloud_iQ.156d42850287ee889fabcfb457ad9095.svg";
export { ForwardRef as ReactComponent };